import moment from "moment";
import React, {useState} from 'react';
import DatePicker from "react-datepicker";
import {Button} from "../../../../../Button";
import {buttonStyle, datePickerCss, root} from "./styles";
import {ReactComponent as DropdownSvg} from "../../../../../../images/dropdown.svg";

export interface RangeDatePickerProps {
    onChange?(targetDate: number): void;
    initialDate?: Date;
    loading?: boolean;
    fromDate?: number;
    toDate?: number;
    format?: string;
}


export const RangeDatePicker: React.FC<RangeDatePickerProps> = ({
    onChange,
    initialDate,
    loading,
    fromDate,
    toDate,
    format = "YYYY/MM/DD",
}) => {
    const [startDate, setStartDate] = useState<Date>(() => initialDate instanceof Date ? initialDate : new Date());
    const [dateTs, setDateTs] = useState<number>(() => startDate.getTime());

    const fromFormatted = React.useMemo(() =>
            moment.unix(fromDate || 0).format(format),
        [fromDate]
    );
    const toFormatted = React.useMemo(() =>
            moment.unix(toDate || 0).format(format),
        [toDate]
    );

    const [open, setOpen] = React.useState(false);


    React.useLayoutEffect(() => {
        const currDay = moment(dateTs);
        onChange?.(currDay.unix());
    }, [dateTs]);

    return (
        <div css={root}>
            <Button css={buttonStyle} onClick={() => {
                setOpen(p => !p);
            }}>{<React.Fragment>
                <div>{loading ? "Calculating range..." : (`${fromFormatted} - ${toFormatted}` || "Select date")}</div>
                <DropdownSvg/>
            </React.Fragment>}</Button>
            {open && <div css={datePickerCss}>
                <DatePicker
                    selected={startDate}
                    onChange={date => {
                        const newDate = (Array.isArray(date) ? date[0] : date) || new Date();
                        setStartDate(newDate);
                        setDateTs(newDate.getTime());
                        setOpen(false);
                    }}
                    inline
                />
            </div>}
        </div>
    );
};